import { ChangePasswordPageState } from './interfaces/ChangePasswordPageState';
import {
  SET_IS_MODAL_OPENED, SetIsModalOpened, ChangePasswordPageActions,
} from './ChangePasswordPage.actions';

const changePasswordPageReducer = (state: ChangePasswordPageState, action: ChangePasswordPageActions): ChangePasswordPageState => {
  switch (action.type) {
    case SET_IS_MODAL_OPENED:
      return setIsModalOpened(state, action);
    default:
      return state;
  }
};

const setIsModalOpened = (state: ChangePasswordPageState, action: SetIsModalOpened): ChangePasswordPageState => ({
  ...state,
  isModalOpened: action.isModalOpened,
});

export default changePasswordPageReducer;
